import { api } from '~/services/api';
import { AxiosError } from 'axios';
import ICustomAxiosRequestConfig from '~/services/custom/ICustomAxiosRequestConfig';

type QrCodeSettingsParams = {
  unit_id: string;
};

export type QrCodeSettingsProps = {
  qr_code_enabled: boolean;
  qr_code_priority_modal_enabled: boolean;
  tolerance: number;
  table_people: number[];
  tables_in_line: number;
  estimated_wait_time_enabled: boolean;
  version: string[];
};

type GetQrCodeSettingsProps = {
  data?: QrCodeSettingsProps;
  status?: number;
  message?: string;
};

type QrCodeSettingsOptions = {
  initialData?: {
    data: QrCodeSettingsProps;
  };
  keepPreviousData?: boolean;
};

export const getQrCodeSettings = async (
  params?: QrCodeSettingsParams,
  serverSide?: { serverSide: boolean }
): Promise<GetQrCodeSettingsProps> => {
  try {
    const { unit_id } = params as QrCodeSettingsParams;
    const { data, status } = await api.get(
      `/line/v1/units/${unit_id}/qrcode/settings`,
      {
        serverSide,
      } as ICustomAxiosRequestConfig
    );
    return {
      data: {
        ...data.data,
        ...((data.data.version || null) !== null &&
        typeof data.data.version === 'string'
          ? {
              version: JSON.parse(
                Buffer.from(data.data.version, 'base64').toString('utf-8')
              ),
            }
          : { version: [] }),
      },
      status,
    };
  } catch (err) {
    const error = err as AxiosError;

    return {
      message: (error.response?.data as any).message,
      status: error.response?.status,
    };
  }
};
